import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/contact_management'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  activeStep: 1,
  uploadResult: {
    sheets: [],
    delimiter: null
  },
  setupResult: {
    columns: {}
  },
  columnMapping: {
    firstName: null,
    lastName: null,
    mail: null,
    title: null,
    jobTitle: null,
    dossier: null,
    picture: null,
    address: null,
    phone: null,
    fax: null,
    externalPublication: null,
    website: null,
    company: null,
    country: null,
    state: null,
    linkedinUrl: null,
    twitterUrl: null,
    facebookUrl: null,
    xingUrl: null,
    threadsUrl: null,
    tiktokUrl: null,
    instagramUrl: null,
    youtubeUrl: null,
    otherUrl: null,
    mediaTopics: null,
    languages: null
  },
  importResult: {
    uploaded: [],
    failed: [],
    total_uploaded: 0,
    total_failed: 0,
    suggestions: [],
    distributionListIds: []
  },
  selectedSheet: null,
  firstRowHasHeaders: 'yes',
  useAiColumnMapping: 'yes',
  autoAddToLists: false,
  autoCreateLists: false,
  selectedListIds: [],
  newListNames: [],
  selectedContactsToReplace: []
})

export default handleActions(
  {
    [Actions.importUploadFileSuccess]: (state, { payload }) => state
      .set('uploadResult', fromJS(payload))
      .set('activeStep', 2),
    [Actions.importSetupSuccess]: (state, { payload }) => {
      let updatedState = state

      if (payload.mapping && Object.keys(payload.mapping).length > 0) {
        Object.keys(payload.mapping).forEach(key => {
          updatedState = updatedState.setIn(['columnMapping', key], fromJS(payload.mapping[key]))
        })
      }

      return updatedState
        .set('setupResult', fromJS(payload))
        .set('activeStep', 3)
    },
    [Actions.importFinalizeSuccess]: (state, { payload }) => state
      .set('importResult', fromJS(payload))
      .set('activeStep', 4),
    [Actions.updateImportFormData]: (state, { payload: { key, value } }) => state.set(key, fromJS(value)),
    [Actions.setColumnMapping]: (state, { payload: { key, value } }) => state.setIn(['columnMapping', key], fromJS(value)),
    [Actions.resetColumnMapping]: state => state.set('columnMapping', initialState.get('columnMapping'))
      .set('activeStep', 2),
    [Actions.setCsvDelimiter]: (state, { payload }) => state.setIn(['uploadResult', 'delimiter'], fromJS(payload)),
    [Actions.closeDetailPages]: state => state,
    [Actions.setSelectedContactsToReplace]: (state, { payload: contactData }) => {
      const contactId = contactData.get('id')
      const alreadySelected = state.get('selectedContactsToReplace').some(contact => contact.get('id') === contactId)

      if (alreadySelected) {
        return state.update('selectedContactsToReplace', contacts => contacts.filter(contact => contact.get('id') !== contactId))
      }

      return state.update('selectedContactsToReplace', contacts => contacts.push(contactData))
    },
    [Actions.replaceAllContacts]: (state, { payload }) => {
      const selectedContacts = state.get('selectedContactsToReplace')

      const newSelectedContacts = fromJS(payload)
        .filter(contact => !selectedContacts.some(selectedContact => selectedContact.get('id') === contact.get('id')))

      if (newSelectedContacts.isEmpty()) {
        return state.set('selectedContactsToReplace',
          initialState.get('selectedContactsToReplace'))
      }

      return state.update('selectedContactsToReplace',
        contacts => contacts.concat(newSelectedContacts))
    },
    [Actions.replaceContactsSuccess]: (state, { payload }) => state
      .updateIn(
        ['importResult', 'suggestions'],
        suggestions => suggestions.filter(
          suggestion => !payload.includes(suggestion.getIn(['contact', 'id']))
        )
      )
      .set('selectedContactsToReplace', initialState.get('selectedContactsToReplace')),
    [Actions.resetImportState]: () => initialState,
    [combineActions(
      Actions.resetState,
      AppActions.resetState
    )]: () => initialState
  },
  initialState
)
